import { render } from "./museumActivityCreate.vue?vue&type=template&id=86d70da6"
import script from "./museumActivityCreate.vue?vue&type=script&lang=js"
export * from "./museumActivityCreate.vue?vue&type=script&lang=js"

import "./museumActivityCreate.vue?vue&type=style&index=0&id=86d70da6&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__